import { Button } from "antd";
import { useContext } from "react";
import PageLoader from "../../components/PageLoader";
import { IMAGE_BASE_URL } from "../../common/Constants";
import { AasetupContext } from ".";
import { useLocation } from "react-router-dom";
const AAFView = () => {
  const location = useLocation();
  const pagePermissions = location.state;

  console.log('AAFSETUP', pagePermissions)
  const { setEditMode, isLoading, AAfData } = useContext(AasetupContext);
  if (isLoading) {
    return <PageLoader />;
  }

  return (
    <>
      <h1 className="pt-[20px] pl-[30px] text-[20px] font-[700] mb-[20px]">
        AAF Setup
      </h1>
      <div className="p-[12px_30px] flex items-center gap-[15px] justify-between border-y border-[#EAEAEA]">
        <h3 className="text-[14px] font-[600]">Approval Advice For Flooring (AAF) Details</h3>
        {(pagePermissions?.create_permission == 1 || pagePermissions?.update_permission == 1) && (
          <Button
            className="flex h-[unset] gap-[10px] min-w-[125px] items-center p-[6px_15px] border-[#0F59F9] text-[#0F59F9] font-[600] text-[13px] "
            onClick={() => setEditMode(true)}
          >
            <img src="/images/edit_ic.svg" alt="edit" />
            Edit Details
          </Button>
        )}
        {/* {pagePermissions?.update_permission == 1 && (
 )} */}
      </div>
      <div className="aa_details p-[20px_30px]">
        <div className="inline-block w-[120px] h-[80px] rounded-[6px] border border-[#DEDEDE] mb-[20px]">
          <img
            className="h-full w-full object-cover"
            src={`${IMAGE_BASE_URL}/${AAfData?.logo}`}
            alt="logo"
          />
        </div>
        <div className="mb-[10px]">
          <label className="block text-[#787486] text-[13px]">S No:</label>
          <div className="text-[13px]">{AAfData?.sno}</div>
        </div>
        <div className="mb-[10px]">
          <label className="block text-[#787486] text-[13px]">
            Name of Company:
          </label>
          <div className="text-[13px]">{AAfData?.company_name}</div>
        </div>
        <div className="mb-[10px]">
          <label className="block text-[#787486] text-[13px]">UEN No:</label>
          <div className="text-[13px]">{AAfData?.uen_no}</div>
        </div>
        <div className="mb-[10px]">
          <label className="block text-[#787486] text-[13px]">
            Enquires Contact No:
          </label>
          <div className="text-[13px]">
            {AAfData?.country_code} {AAfData?.phone_number}
          </div>
        </div>
        <div className="mb-[10px]">
          <label className="block text-[#787486] text-[13px]">Address:</label>
          <div className="text-[13px]">{AAfData?.address}</div>
        </div>
        <div className="mb-[10px]">
          <label className="block text-[#787486] text-[13px]">
            Terms and Conditions:
          </label>
          <div className="text-[13px] max-w-[800px]">{AAfData?.terms}</div>
        </div>
      </div>
    </>
  );
};

export default AAFView;
